(() => {
  const idKey = 'efx-wishlist-products';
  const itemKey = 'efx-wishlist-items';
  const buttonSelector = '[data-efx-wishlist], [data-efx-related-wishlist], [data-wishlist-product]';

  const readJson = (key, fallback) => {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      return value == null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  };

  const readIds = () => {
    const value = readJson(idKey, []);
    return Array.isArray(value) ? [...new Set(value.map(String))] : [];
  };

  const readItems = () => {
    const value = readJson(itemKey, []);
    return Array.isArray(value) ? value.filter((item) => item && item.id).map((item) => ({ id: String(item.id), handle: item.handle || '' })) : [];
  };

  const getButtonId = (button) => String(button.dataset.wishlistProduct || button.dataset.efxWishlist || button.dataset.efxRelatedWishlist || '');

  const catalogItems = () => {
    const element = document.getElementById('WishlistProductCatalog');
    if (!element) return [];
    try {
      const value = JSON.parse(element.textContent);
      return Array.isArray(value) ? value.map((item) => ({ id: String(item.id), handle: item.handle || '' })) : [];
    } catch (error) {
      return [];
    }
  };

  const reconcileItems = () => {
    const ids = readIds();
    const known = new Map([...readItems(), ...catalogItems()].map((item) => [String(item.id), item.handle]));

    document.querySelectorAll(buttonSelector).forEach((button) => {
      const id = getButtonId(button);
      if (id && button.dataset.wishlistHandle) known.set(id, button.dataset.wishlistHandle);
    });

    const items = ids.map((id) => ({ id, handle: known.get(id) || '' }));
    try { localStorage.setItem(itemKey, JSON.stringify(items)); } catch (error) {}
    return items;
  };

  const syncUi = () => {
    const ids = readIds();
    document.querySelectorAll(buttonSelector).forEach((button) => {
      const active = ids.includes(getButtonId(button));
      button.setAttribute('aria-pressed', String(active));
      button.classList.toggle('active', active);
      const label = button.getAttribute('aria-label') || 'product';
      const productName = label.replace(/^(Add|Remove) /i, '').replace(/ (to|from) wishlist$/i, '');
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${productName} ${active ? 'from' : 'to'} wishlist`);
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
      badge.textContent = String(ids.length);
      badge.style.display = ids.length ? '' : 'none';
    });

    document.querySelectorAll('[data-wishlist-link]').forEach((link) => {
      link.classList.toggle('has-items', ids.length > 0);
      link.setAttribute('aria-label', `Wishlist, ${ids.length} ${ids.length === 1 ? 'item' : 'items'}`);
    });
  };

  const announceChange = () => {
    reconcileItems();
    syncUi();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { ids: readIds() } }));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);
    if (!button) return;

    if (button.dataset.wishlistManaged === 'section') {
      window.setTimeout(announceChange, 0);
      return;
    }

    event.preventDefault();
    const id = getButtonId(button);
    if (!id) return;
    const ids = readIds();
    const next = ids.includes(id) ? ids.filter((savedId) => savedId !== id) : [...ids, id];
    try { localStorage.setItem(idKey, JSON.stringify(next)); } catch (error) {}
    announceChange();
  });

  window.SkylineWishlist = { readIds, readItems: reconcileItems, sync: announceChange };
  document.addEventListener('DOMContentLoaded', announceChange);
  window.addEventListener('storage', (event) => {
    if (event.key === idKey || event.key === itemKey) announceChange();
  });
})();
